import { render, staticRenderFns } from "./RolePermissionsTable.vue?vue&type=template&id=00db1e8a&scoped=true&"
import script from "./RolePermissionsTable.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db1e8a",
  null
  
)

export default component.exports